<template>
  <div class="pre-register-wrapper">
    <div id="preloader2">
      <div id="status2">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    
    <form-wizard ref="pre_reg_form" class="pre-register-form" >

      <tab-content
        v-if="
          !this.$route.query.add_visitor || this.$route.query.comingFromPassport
        "
      >
        <UserTypeTab
          @next="nextTab"
          @finish="finishVisit"
          @changeTab="navigateToImageUpload"
          @updateUserTypeId = "updateUserTypeId"
          @updateShowSections="updateShowSections"
        />
      </tab-content>

      <tab-content
        v-if="
          (!getDifferentUserType &&
            !getNotAllowedToRegister &&
            !getVisitExists &&
            !getFromLogin &&
            !getHasVisitedPage) ||
          (getHasVisitedPage && !getRegisterPassportAcc && !getFromLogin) ||
          (this.$route.query.add_visitor &&
            !this.$route.query.comingFromPassport)
        "
      >
        <PersonalDetailsTab
          @next="nextTab"
          @finish="finishVisit"
          @getFormData="getData"
          @updateShowSections="updateShowSections"
          :sectionPayload="sectionPayload"
        ></PersonalDetailsTab>
      </tab-content>

      <tab-content v-if="getVisitExists && !this.$route.query.add_visitor">
        <VisitDateExists @changeTab="navigateToTab"></VisitDateExists>
      </tab-content>

      <tab-content
        v-if="
          (getDifferentUserType || getNotAllowedToRegister) &&
          !this.$route.query.add_visitor
        "
      >
        <DifferentUserTypeTab
          @changeTab="navigateToTab"
          @finish="finishVisit"
          @next="nextTab"
        ></DifferentUserTypeTab>
      </tab-content>

      <tab-content 
        v-for="(section,index) in getSections" :key="index">
        <SectionTab
          :sectionData="section"
          :isLastSection="index == getSections.length - 1"
          :isLastTab="index == getSections.length - 1 && imgRequiredConfirm"
          @updateShowSections="updateShowSections"
          @updateCustomField="updateCustomField"
          @nextAction="nextAction"
        />
      </tab-content>

      <tab-content v-if="showHost">
        <HostTab @next="nextTab" @finish="finishVisit"></HostTab>
      </tab-content>

      <tab-content
        v-if="showImageUpload"
      >
        <ImageUploadTab @next="finishVisit"></ImageUploadTab>
      </tab-content>

      <span slot="back"></span>
      <span slot="next"></span>
      <span slot="finish"></span>

      <b-modal
        no-fade
        hide-header
        hide-footer
        :title="$t('preRegisteration.visiPointPassportExists')"
        id="already-have-email"
        ref="already_have_email"
      >
        <div class="modal-head">
          <span class="modal-head-title">{{$t('preRegisteration.visiPointPassportExists')}}</span>
          <span class="close-icon" @click="hideModal"
            ><svg
              style="margin-inline-end: 20px; margin-inline-start: 54px; cursor: pointer"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                fill="#F46A6A"
              />
            </svg>
          </span>
        </div>
        <div class="modal-body-msg text-center" v-html="$t('preRegisteration.alreadyHaveAccount')" />
        <div class="modal-f" v-if="this.form">
          <button class="login-btn">
            <router-link
              class="login-link"
              :to="{
                path: '/passport',
                query: {
                  email: !this.$route.query.add_visitor ? this.form.email : (!getEmailDuplicatedCheck || !getEmailDuplicatedCheck.available ? this.form.email : ''),
                  phone: !this.$route.query.add_visitor ? this.form.phone : (!getPhoneDuplicatedCheck || !getPhoneDuplicatedCheck.available ? this.form.phone : ''),
                  redirect_url: !this.$route.query.add_visitor ? this.$router.currentRoute.path : undefined,
                  visit_date: !this.$route.query.add_visitor ? (this.formatedVisitDate
                    ? this.formatedVisitDate
                    : '') : undefined,
                  visit_time: !this.$route.query.add_visitor ? (this.formattedTime ? this.formattedTime : '') : undefined,
                  area_id: !this.$route.query.add_visitor ? (this.getSelectedArea ? this.getSelectedArea.id : '') : undefined,
                  registration_method: !this.$route.query.add_visitor ? (this.getSelectedUserType
                    ? this.getSelectedUserType[0].pre_registration_method
                    : '') : undefined,
                  entity_id: !this.$route.query.add_visitor ? (this.getSelectedUserType
                    ? this.getSelectedUserType[0].entity_id
                    : '') : undefined,
                  user_type_id: !this.$route.query.add_visitor ? (this.getSelectedUserType
                    ? this.getSelectedUserType[0].id
                    : '') : undefined,
                  journey_flow_id: !this.$route.query.add_visitor ? getJourneyFlowId : undefined,
                  emailExists: !this.$route.query.add_visitor ? true : undefined,
                  add_visitor: this.$route.query.add_visitor ? true : '',
                  serverUrl: this.$route.query.add_visitor ? getPreRegistrationData.serverFrontUrl : '',
                  visit_url: this.$route.query.add_visitor ? this.$route.params.id : '',
                },
              }"
              >{{$t('common.login')}}</router-link
            >
          </button>
          <button class="one-time-btn">
            <router-link
              class="one-time-login-link"
              :to="{
                path: '/login-one-time',
                query: {
                  email: !this.$route.query.add_visitor ? this.form.email : (!getEmailDuplicatedCheck || !getEmailDuplicatedCheck.available ? this.form.email : ''),
                  phone: !this.$route.query.add_visitor ? this.form.phone : (!getPhoneDuplicatedCheck || !getPhoneDuplicatedCheck.available ? this.form.phone : ''),
                  visit_date: !this.$route.query.add_visitor ? this.formatedVisitDate : undefined,
                  visit_time: !this.$route.query.add_visitor ? this.formattedTime : undefined,
                  entity_id: !this.$route.query.add_visitor ? getSelectedUserType[0].entity_id : undefined,
                  user_type_id: !this.$route.query.add_visitor ? getSelectedUserType[0].id : undefined,
                  area_id: !this.$route.query.add_visitor ? getSelectedArea.id : undefined,
                  registration_method: !this.$route.query.add_visitor ?
                    getSelectedUserType[0].pre_registration_method : undefined,
                  journey_flow_id: !this.$route.query.add_visitor ? getJourneyFlowId : undefined,
                  redirect_url: !this.$route.query.add_visitor ? location : undefined,
                  add_visitor: this.$route.query.add_visitor ? true : '',
                  serverUrl: this.$route.query.add_visitor ? getPreRegistrationData.serverFrontUrl : '',
                  visit_url: this.$route.query.add_visitor ? this.$route.params.id : '',
                },
              }"
              >{{ $t('preRegisteration.oneTimeLogin')}}</router-link
            >
          </button>
        </div>
      </b-modal>
    </form-wizard>
  </div>
</template>

<script>
import UserTypeTab from "@/components/preregistration/UserTypeTab";
import PersonalDetailsTab from "@/components/preregistration/PersonalDetailsTab";
import HostTab from "@/components/preregistration/hostTab";
import SectionTab from "@/router/views/preRegistrationForm/Section";
import { layoutComputed } from "@/state/helpers";
import { mapActions, mapGetters, mapState } from "vuex";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import ImageUploadTab from "@/components/preregistration/ImageUploadTab";
import DifferentUserTypeTab from "@/components/preregistration/DifferentUserTypeTab";
import VisitDateExists from "@/components/preregistration/VisitDateExists";
import { cloneDeep } from "lodash";

export default {
  page: {
    title: "Pre-Registration form",
  },
  name: "PreRegistrationForm",
  components: {
    FormWizard,
    TabContent,
    UserTypeTab,
    ImageUploadTab,
    DifferentUserTypeTab,
    PersonalDetailsTab,
    VisitDateExists,
    HostTab,
    SectionTab
  },
  data() {
    return {
      form: null,
      location: window.location.href,
      userTypeId: null,
      showSections: false,
      customSections: [],
    };
  },
  watch: {
    getSections(sections) {
      this.customSections = sections;
    },

    getRedirectLoader: {
      handler: function (value) {
        // watch it
        console.log("Prop changed: ", value);
        if (value) {
          document.getElementById("preloader2").style.display = "block";
          document.getElementById("status2").style.display = "block";
        } else {
          document.getElementById("preloader2").style.display = "none";
          document.getElementById("status2").style.display = "none";
   
        }
      },
      deep: true,
    },
    getEmailDuplicatedCheck(emailDuplicatedCheck) {
      console.log("watch", emailDuplicatedCheck, this.getHasFilledForm);
      if (
        this.getHasFilledForm &&
        emailDuplicatedCheck &&
        !emailDuplicatedCheck.available &&
        emailDuplicatedCheck.msg.length == 0
      ) {
        console.log("yes watch");
        setTimeout(() => {
          this.$bvModal.show("already-have-email");
        }, 1500);
      }
    },

    getPhoneDuplicatedCheck(phoneDuplicatedCheck) {
      if (
        this.getHasFilledForm &&
        phoneDuplicatedCheck &&
        !phoneDuplicatedCheck.available &&
        phoneDuplicatedCheck.msg.length == 0
      ) {
        this.$refs["already_have_email"]?.show();
      }
    },
  },
  beforeMount() {
    this.clearSections();
    this.setIsLoading(false);

    if (
      !this.$route.query ||
      (!this.$route.query.comingFromPassport && !this.$route.query.add_visitor)
    ) {
      this.resetPreRegistrationState();
    }
    this.setHasFilledForm(false);
    setTimeout(() => {
      if (this.getJourneyFlowId)
        this.getJourneyFlowCompliance(this.getJourneyFlowId);
    }, 2000);
  },
  mounted() {
    if (!this.getRedirectLoader) {
      document.getElementById("preloader2").style.display = "none";
      document.getElementById("status2").style.display = "none";
    }

    if (this.$route.query.add_visitor || this.$route.query.comingFromPassport) {
      this.selectRedirectLoader(true);
    }

    if (this.$route.query.comingFromPassport) {
      this.selectFirstName(
        this.$route.query.first_name
          ? decodeURIComponent(this.$route.query.first_name)
          : null
      );
      this.selectLastName(
        this.$route.query.last_name
          ? decodeURIComponent(this.$route.query.last_name)
          : null
      );
      this.selectPhone(
        this.$route.query.phone
          ? decodeURIComponent(this.$route.query.phone)
          : null
      );
      this.selectEmail(
        this.$route.query.email
          ? decodeURIComponent(this.$route.query.email).replace(" ", "+")
          : null
      );
      this.setImage(
        this.$route.query.image
          ? decodeURIComponent(this.$route.query.image)
          : null
      );
    }
  },
  computed: {
    ...mapState("preRegistration", ["compliance"]),
    ...mapGetters("preRegistration", [
      "getSelectedUserType",
      "getSelectedArea",
      "getVisitDate",
      "getVisitTime",
      "getEmail",
      "getPhone",
      "getCompliance",
      "getHasFilledForm",
      "getDifferentUserType",
      "getNotAllowedToRegister",
      "getHasVisitedPage",
      "getFromLogin",
      "getRegisterPassportAcc",
      "getSwitch",
      "getVisitExists",
      "getSelectedHost",
      "getSections",
    ]),
    ...mapGetters("preRegistration", ["getJourneyFlowId", "getRedirectLoader"]),
    ...mapGetters("userType", ["getTouchModeStatus", "getHostUserTypesExist", "getPreRegistrationData"]),
    ...mapGetters("authfack", [
      "getPhoneDuplicatedCheck",
      "getEmailDuplicatedCheck",
    ]),
    ...layoutComputed,
    imgRequiredConfirm() {
      return this.$route.query.add_visitor && ((this.getPreRegistrationData && this.getPreRegistrationData.user && this.getPreRegistrationData.user.image && this.getCompliance.is_image_required) || !this.getCompliance.is_image_required);
    },
    formatedVisitDate() {
      return !this.$route.query.add_visitor
        ? this.getVisitDate?.toISOString().split("T")[0]
        : "";
    },
    formattedTime() {
      if (!this.$route.query.add_visitor) {
        if (this.getVisitTime) {
          const visit_time = new Date(this.getVisitTime);
          return visit_time.toLocaleString("en-US", {
            hour: "numeric",
            minute: "numeric",
            hour12: true,
          });
        } else {
          return null;
        }
      }
      return "";
    },
    sectionPayload(){
      return {
        area_id : this.getSelectedArea?.id ,
        user_type_id : this.userTypeId ,
      }
    },
    showHost() {
      return (
        ((!this.showSections &&
          this.getTouchModeStatus &&
          this.getHostUserTypesExist &&
          !this.getDifferentUserType &&
          !this.getNotAllowedToRegister &&
          !this.getVisitExists) ||
          (this.getTouchModeStatus &&
            this.getHostUserTypesExist &&
            this.getSwitch)) &&
        !this.$route.query.add_visitor
      );
    },
    showImageUpload() {
      return (
        (!this.showSections &&
          this.getCompliance.is_image_required &&
          !this.getDifferentUserType &&
          !this.getNotAllowedToRegister &&
          !this.getVisitExists &&
          (!this.getTouchModeStatus ||
            !this.getHostUserTypesExist ||
            this.getSelectedHost ||
            this.getSelectedHost == "")) ||
        (this.getCompliance.is_image_required &&
          this.getSwitch &&
          (!this.getTouchModeStatus ||
            !this.getHostUserTypesExist ||
            this.getSelectedHost ||
            this.getSelectedHost == "")) ||
        (!this.showSections && !this.getPreRegistrationData?.user?.image && this.getCompliance.is_image_required && this.$route.query.add_visitor)
      );
    },
  },
  methods: {
    ...mapActions("preRegistration", [
      "getJourneyFlowCompliance",
      "createExpectedVisit",
      "resetPreRegistrationState",
      "selectFirstName",
      "selectLastName",
      "selectEmail",
      "selectPhone",
      "setImage",
      "setRegisterPassportAcc",
      "setHasFilledForm",
      "selectRedirectLoader",
      "confirmExpectedVisitPassport",
      "confirmExpectedVisit",
      "clearSections",
      "setSections",
      "setIsLoading"
    ]),
    navback(){
      this.$refs.pre_reg_form.prevTab()
    },
    navtoz(){
      this.$refs.pre_reg_form.nextTab()
    },
    updateShowSections(showSections){
      this.showSections = showSections;
    },
    updateCustomField(section) {
      let sectionIndex = this.customSections?.findIndex(customSection => customSection.id == section.id)
      if (sectionIndex >= 0) this.customSections[sectionIndex] = section;
      this.customSections[sectionIndex] = cloneDeep(this.customSections[sectionIndex]);
    },
    updateUserTypeId(userTypeId){
      this.userTypeId = userTypeId
    },
    nextTab(registerPassportAcc) {
      // console.log('nextTab', this.$refs.pre_reg_form, registerPassportAcc);
      if (registerPassportAcc == true || registerPassportAcc == false)
        this.setRegisterPassportAcc(registerPassportAcc);
      setTimeout(() => {
        this.$refs.pre_reg_form.nextTab();
      }, 0);
    },
    nextAction(isLastSection) {
      console.log('this.customSections', this.customSections);
      this.setSections(this.customSections);
      if (isLastSection && !this.showHost && !this.showImageUpload) this.finishVisit();
      else this.nextTab();
    },
    finishVisit(registerPassportAcc) {
      console.log("getRegisterPassportAcc", registerPassportAcc);
      if (
        this.$route.query.add_visitor &&
        this.$route.query.comingFromPassport
      ) {
        this.confirmExpectedVisitPassport();
      } else if (this.$route.query.add_visitor) {
        this.confirmExpectedVisit();
      } else {
        this.createExpectedVisit({
          enable_switch_usertype: registerPassportAcc == "switch" ? 1 : 0,
          registerPassportAcc:
            registerPassportAcc == true
              ? true
              : this.form && this.form.register_check
              ? this.form.register_check
              : false,
          data: this.$route.query,
        }).then(() => {
          // setTimeout(() => {
          //   this.$router.push(this.$router.currentRoute.path + "/success");
          // }, 1000);
        });
      }
    },
    getData(data) {
      console.log("data", data);
      this.form = data;
    },
    navigateToTab() {
      this.$refs.pre_reg_form.changeTab(2, 0);
    },
    navigateToImageUpload() {
      this.$refs.pre_reg_form.changeTab(0, 2);
    },
    hideModal() {
      this.$refs["already_have_email"]?.hide();
    },
  },
};
</script>
<style lang="scss">
.pre-register-wrapper {
  display: flex;
  margin: auto;
  align-items: center;
  padding-top: 0;
  justify-content: center;
  .pre-register-form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    max-width: 491px;
    height: 100%;
    max-height: 100%;
    text-align: center;
    padding: 0 6px 0 6px;
    margin: 0;
    margin-bottom: 40px;
    .pre-reg-head-tab1 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      max-width: 491px;
      text-align: center;
      background-color: #fff;
      margin-top: 84px;
    }
    .wizard-tab-content {
      padding-top: 0 !important;
    }
  }
}

div#already-have-email {
  // background: #e5e5e5;
  position: fixed;
}
div#already-have-email___BV_modal_content_ {
  width: 491px;
  height: 273px;
  background: #ffffff;
  border-radius: 26px;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  margin-top: 200px;
  margin-inline-end: 0px;
  margin-bottom: 180px;
  margin-inline-start: 5px;
  .modal-dialog {
    margin: 0px !important;
  }
  .modal-body {
    padding: 0px !important;
    margin: 0px !important;
    .modal-head {
      display: flex;
      margin-top: 36px;
      justify-content: space-evenly;
      span.modal-head-title {
        margin-inline-start: 157px;

        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        color: #c7c7c7;
      }
    }
    .modal-body-msg {
      width: 403px;
      font-weight: 400;
      font-size: 16px;
      line-height: 27px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #666666;
      margin: 26px auto 33px auto;

      .bold-txt {
        font-weight: 700;
      }
    }
    .modal-f {
      margin: 0px 77px 39px 77px;
      display: flex;
      justify-content: center;
      .login-btn {
        width: 147px;
        height: 37px;
        border: none;
        background: #103f5e;
        color: white !important;
        border-radius: 18.5px;
        margin-inline-end: 44px;
        a.login-link {
          font-weight: 400;
          font-size: 16px;
          line-height: 19px;
          text-align: center;
          color: #ffffff;
        }
      }
      .one-time-btn {
        width: 147px;
        height: 37px;
        background: #ffffff;
        border: 2px solid #103f5e;
        border-radius: 18.6275px;
        a.one-time-login-link {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          text-align: center;
          letter-spacing: 0.25px;
          color: #103f5e;
        }
      }
      .one-time-btn:lang(ar){
        width: 275px;
      }
    }
  }
}
@media (max-width: 992px) {
  div#already-have-email___BV_modal_content_ {
    width: 347px;

    background: #ffffff;
    border-end-start-radius: 17px;
    border-end-end-radius: 17px;
    border-start-start-radius: 17px;
    border-start-end-radius: 17px;

    margin: 150px 75px;
    .modal-body .modal-body-msg {
      background: #ffffff !important;
      width: 100% !important;
    }
    .modal-content {
      height: 247px !important;
    }
    .modal-dialog {
      margin: 0px !important;
      height: 247px;
    }
    .modal-body {
      padding: 0px !important;
      margin: 0px !important;
      .modal-head {
        display: flex;
        margin-top: 24px;
        align-items: center;
        span.modal-head-title {
          margin-inline-start: 96px;
          font-weight: 700;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          color: #c7c7c7;
        }
      }
      .modal-body-msg {
        font-weight: 400;
        font-size: 14px;
        line-height: 27px;
        text-align: center;
        letter-spacing: 0.25px;
        color: #666666;
        width: 273px;
        margin: 18px auto 0px auto;
        .bold-txt {
          font-weight: 700;
        }
      }
      .modal-f {
        margin: 0px auto 22px auto;
        display: flex;
        justify-content: center;
        background: #ffffff;
        border-end-start-radius: 17px;
        border-end-end-radius: 17px;
        padding-top: 19px !important;
        .login-btn {
          width: 128px;
          height: 33px;
          border: none;
          background: #103f5e;
          color: white !important;
          border-radius: 16.5px;
          margin-inline-end: 17.5px;
          margin-bottom: 22px;
          a.login-link {
            font-weight: 400;
            font-size: 14px;
            line-height: 17px;
            text-align: center;
            color: #ffffff;
          }
        }
        .one-time-btn {
          width: 128px;
          height: 33px;
          background: #ffffff;
          border: 2px solid #103f5e;
          border-radius: 16.6275px;
          margin-bottom: 22px;
          a.one-time-login-link {
            font-weight: 700;
            font-size: 14px;
            line-height: 17px;
            text-align: center;
            letter-spacing: 0.25px;
            color: #103f5e;
          }
        }
      }
    }
  }
}
@media (max-width: 449px) {
  div#already-have-email___BV_modal_content_ {
    width: 100%;
    border-end-start-radius: 17px;
    border-end-end-radius: 17px;
    margin: 180px 0px !important;
    .modal-body .modal-body-msg {
      background: #ffffff !important;
      width: 100% !important;
    }
  }
}
</style>
